import { useQuery } from "react-query";
import SearchService from "../api/services/SearchService";

interface IFormData {
  email: string;
  message: string;
  phone: string;
}

export const useFeedbackForm = (queryKey: string, formData: IFormData) => {
  const { data, isLoading, refetch, isError, isSuccess } = useQuery(
    [queryKey, formData],
    async () =>
      await SearchService.sendFeedbackForm({
        webpage_id: "UNKNOWN",
        webpage_title: window.document.title,
        webpage_url: window.location.toString(),
        ...formData,
      }),
    {
      enabled: !!formData.email && !!formData.message,
    }
  );

  return {
    feedBackFormData: data?.data?.inquiry,
    isFeedBackFormLoading: isLoading,
    feedBackFormSuccess: isSuccess,
    feedBackFormError: isError,
    fetchFeedBackFormData: refetch,
  };
};
